var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeopleManagedDisabledPeople({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFB800",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.06 7-.334-.117a.212.212 0 0 1-.13-.135 1.9 1.9 0 0 1-.01-.813.205.205 0 0 1 .046-.083 3.877 3.877 0 0 0 .988-2.946A2.683 2.683 0 0 0 10 0c-.388 0-.771.089-1.118.262a.208.208 0 0 0-.084.302c.463.693.707 1.508.702 2.34a5.22 5.22 0 0 1-.768 3.02.207.207 0 0 0-.024.18c.02.06.066.109.126.13 1.26.464 2.592.977 3.192 2.01.05.086.155.124.25.09.42-.155.855-.267 1.298-.333a.208.208 0 0 0 .051-.398c-.458-.195-.98-.389-1.566-.603z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.006 8.97a.21.21 0 0 0 .06-.292c-.416-.632-1.351-1.009-3.174-1.68l-.333-.117a.208.208 0 0 1-.127-.131 1.9 1.9 0 0 1-.015-.817.205.205 0 0 1 .046-.083 3.877 3.877 0 0 0 .988-2.946A2.683 2.683 0 0 0 5.833 0a2.683 2.683 0 0 0-2.621 2.904 3.85 3.85 0 0 0 .972 2.93c.019.02.033.043.042.07.067.268.077.549.027.822a.208.208 0 0 1-.131.149L3.774 7C2.102 7.614.894 8.058.515 8.814A6.285 6.285 0 0 0 0 11.25c0 .23.187.417.417.417h8.052a.21.21 0 0 0 .186-.114 6.692 6.692 0 0 1 2.35-2.584zM14.583 9.167A5.417 5.417 0 1 0 20 14.583a5.423 5.423 0 0 0-5.417-5.416zm2.652 6.89a.833.833 0 1 1-1.178 1.178l-1.474-1.473-1.473 1.473a.833.833 0 1 1-1.178-1.178l1.473-1.474-1.473-1.473a.833.833 0 1 1 1.178-1.178l1.473 1.473 1.474-1.473a.833.833 0 1 1 1.178 1.178l-1.473 1.473 1.473 1.474z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleManagedDisabledPeople);
export default __webpack_public_path__ + "static/media/people-managed-disabled-people.2808b80e24118087ea58ca4572571601.svg";
export { ForwardRef as ReactComponent };